// 透過 @ay-nestjs/share 產生
/* eslint-disable */
import { wsc } from '../wsc';
import { Observable } from 'rxjs';
import { ReportData } from './dto/fetch-report-data.dto';
import { FetchReportResponse } from './dto/fetch-report-response.dto';

export class CustomPrivateMessageModel {
  static accountStart(profileId: number): Promise<any> {
    return wsc.execute(
      '/ws/custom-private-message/accountStart',
      profileId,
    ) as any;
  }

  static accountClose(profileId: number): Promise<any> {
    return wsc.execute(
      '/ws/custom-private-message/accountClose',
      profileId,
    ) as any;
  }

  static fetchAccountProfiles(profileId: number): Promise<
    {
      accountId: number;
      accountName: string;
      permission: 'read' | 'read-write';
    }[]
  > {
    return wsc.execute(
      '/ws/custom-private-message/fetchAccountProfiles',
      profileId,
    ) as any;
  }

  static addAccountProfiles(
    profileId: number,
    permissions: {
      accountIds: number[];
      permission: 'read' | 'read-write';
    }[],
  ): Promise<{ accountId: number; accountName: string }[]> {
    return wsc.execute(
      '/ws/custom-private-message/addAccountProfiles',
      profileId,
      permissions,
    ) as any;
  }

  static fetchReport(
    botId: number,
    start: Date,
    end: Date,
    paging: {
      page: number;
      size: number;
    },
  ): Promise<FetchReportResponse> {
    return wsc.execute(
      '/ws/custom-private-message/fetchReport',
      botId,
      start,
      end,
      paging,
    ) as any;
  }

  static downloadReport(
    botId: number,
    start: Date,
    end: Date,
  ): Promise<ReportData[]> {
    return wsc.execute(
      '/ws/custom-private-message/downloadReport',
      botId,
      start,
      end,
    ) as any;
  }

  static fetchReportAccounts(): Promise<
    { id: number; name: string; account: string }[]
  > {
    return wsc.execute('/ws/custom-private-message/fetchReportAccounts') as any;
  }

  static checkProfileChatting(profileId: number): Promise<boolean> {
    return wsc.execute(
      '/ws/custom-private-message/checkProfileChatting',
      profileId,
    ) as any;
  }

  static fetchProfileChatAccountIds(profileId: number): Promise<number[]> {
    return wsc.execute(
      '/ws/custom-private-message/fetchProfileChatAccountIds',
      profileId,
    ) as any;
  }

  static fetchProfileAccountPermissions(
    profileId: number,
  ): Promise<'read' | 'read-write'> {
    return wsc.execute(
      '/ws/custom-private-message/fetchProfileAccountPermissions',
      profileId,
    ) as any;
  }

  static subscribeInChat(): Observable<{
    companyId: number;
    accountId: number;
    profileId: number;
    inChat: boolean;
    closedBy?: 'USER' | 'STAFF';
  }> {
    return wsc.subscribe('/ws/custom-private-message/subscribeInChat') as any;
  }
}
// 61b6e320d2cc37000b1b463eb3a0d6304771308740d69aa924acd08b97cdcd96
